// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-link--2KKE4{box-sizing:border-box;color:#000;display:inline-block;font-size:15px;padding:16px 36px 16px 16px;text-decoration:none;width:100%;transition:0.2s background}.menu-link--2KKE4.depth-0{font-size:16px}.menu-link--2KKE4.depth-1{padding-left:30px}.menu-link--2KKE4 svg path,.menu-link--2KKE4 svg rect{fill:#fff}\n", ""]);
// Exports
exports.locals = {
	"menu-link": "menu-link--2KKE4"
};
module.exports = exports;
